import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoEstablecimientoRanking(props) {
    
  var options = {
    series: props.series,
    chart: {
    height: 350,
    type: 'line',
    stacked: false
  },
  dataLabels: {
    enabled: true,
    formatter : function (val) {
      return global.decimalFormat(val.toFixed(2))
    }
  },
  stroke: {
    width: [1, 1, 4]
  },
  title: {
    text: 'Establecimiento - Ranking de Ventas',
    align: 'left',
    offsetX: 110
  },
  xaxis: {
    categories: props.establecimientos,
  },
  yaxis: [
    {
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#008FFB'
      },
      labels: {
        style: {
          colors: '#008FFB',
        },
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      },
      // title: {
      //   text: "Income (thousand crores)",
      //   style: {
      //     color: '#008FFB',
      //   }
      // },
      tooltip: {
        enabled: true
      }
    },
    {
      // seriesName: 'Income',
      opposite: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#00E396'
      },
      labels: {
        style: {
          colors: '#00E396',
        },
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      },
      // title: {
      //   text: "Operating Cashflow (thousand crores)",
      //   style: {
      //     color: '#00E396',
      //   }
      // },
    },
    {
      // seriesName: 'Revenue',
      opposite: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#FEB019'
      },
      labels: {
        style: {
          colors: '#FEB019',
        },
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      },
      // title: {
      //   text: "Revenue (thousand crores)",
      //   style: {
      //     color: '#FEB019',
      //   }
      // }
    },
    {
      // seriesName: 'Revenue',
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#ea4335'
      },
      labels: {
        style: {
          colors: '#ea4335',
        },
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      },
      // title: {
      //   text: "Revenue (thousand crores)",
      //   style: {
      //     color: '#FEB019',
      //   }
      // }
    }
  ],
  tooltip: {
    fixed: {
      enabled: true,
      position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
      offsetY: 30,
      offsetX: 60
    },
  },
  legend: {
    horizontalAlign: 'left',
    offsetX: 40
  }
  };

  var chart = new Chart(document.querySelector("#chart"), options);
  chart.render();

    return (
        <div id="chart">
            <Chart options={options} series={options.series} width={1000} />
        </div>
    );
}